import React, { useState, useMemo, useEffect } from "react";
import CircularLoader from "../../common/CircularLoader/CircularLoader";
import {
  apiGetRequest,
  addFiltersAndPagination,
  apiPostRequest,
} from "../../../helpers/Requests";
import { BiPlus } from "react-icons/bi";
import PaginationComponent from "../../common/Pagination/index";
import CustomButton from "../../common/Button/CustomButton";
import Search from "../../common/Search/Search";
import {
  emptyPaginationObj,
  PARENT_FORM_CATEGORY_SLUG,
  PARTICIPANT_LIST_LIMIT,
  SORT_TYPE,
  USER_ROLE,
} from "../../../Constants/constant.js";
import {
  DATA_FORMATTER_FOR_DYNAMICS_FORMS,
  getPaginationObj,
  getUrlRole,
  selectedTabState,
  SilHomeselectedTabState,
} from "../../../Utils/utils.js";
import ModalSkeleton from "../ModalSkeleton";
import _ from "lodash";
import { useSelector } from "react-redux";
import { getSelectedTabSelector } from "../../../store/selector/auth.selector";
import ActionsForSubmitPtForms from "./ActionsForSubmitPtForms";
import apiCall from "store/services/sp.services";
import { toast } from "react-toastify";
import SelectOption from "components/common/Select/Select";
import { isFrontlineEmployeeUser, roleAccess } from "helpers/RolesPermission";
import CheckBox from "components/common/checkBox/checkbox";
import { MdMarkEmailRead } from "react-icons/md";
import MultipleEmailModal from "components/DynamicForms/ViewFormTemplate/MultipleEmailModal";
import {
  URL_FORM_SEND_EMAIL_FOR_SP,
  URL_FORM_SEND_EMAIL_FOR_WORKER,
  URL_SHOW_OR_HIDE_PT_FORM_TO_WORKER,
  URL_SIL_ACCOMMODATION_FORM_LIST_BY_CATEGORY,
} from "store/services/URL";
import { BLK_PORTAL_PREMISSION_KEYS_CHILDREN } from "store/constants";
import { getUser } from "store/selector/auth.selector";
import { HiOutlineTrash } from "react-icons/hi";
import BulkDeleteFormModal from "../../ServiceProvider/SubmittedFormsView/BulkDeleteFormModal";

const CategoryFormsListing = (props) => {
  const {
    buttonText,
    slug,
    particpantUuid,
    role = null,
    participantId,
    categoryUuid = null,
  } = props;
  const showSerialColumn =
    Boolean(categoryUuid) ||
    slug === PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG ||
    slug === PARENT_FORM_CATEGORY_SLUG.MEDICATION.SLUG ||
    slug === PARENT_FORM_CATEGORY_SLUG.HIGH_CARE.SLUG ||
    slug === PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG;
  const [toggleState, setToggleState] = useState(selectedTabState.get());
  const selectedTabSelector = useSelector(getSelectedTabSelector);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState(null);

  const [supportPlans, setSupportPlans] = React.useState([]);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [request, setRequest] = React.useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [allSelected, setAllSelected] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [isShowMultipleEmail, setIsShowMultipleEmail] = useState(false);
  const [emailSendLoader, setEmailLoader] = useState(false);
  const currentLogedInUser = useSelector(getUser);
  const [selectedFormForEmail, setSelectedFormForEmail] = useState(null);

  const [showToWorkerMap, setShowToWorkerMap] = useState({});
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);

  const canSendParticipantEform =
    roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) ||
    (isFrontlineEmployeeUser() &&
      roleAccess(
        [],
        "participant",
        BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.FORM.SEND_EMAIL
      ));

  useEffect(() => {
    // alert("hi this");
    const tabStateHandler =
      role === "sil" ? SilHomeselectedTabState : selectedTabState;

    const currentTab = tabStateHandler.get();
    if (
      currentTab &&
      currentTab.hasOwnProperty("isModalOpen") &&
      currentTab.hasOwnProperty("slug") &&
      currentTab.slug === slug
    ) {
      setIsModalOpen(true);
      fetchFormTempletes(`${slug}`, { page: 1 });
      delete currentTab.isModalOpen;
      tabStateHandler.save(JSON.stringify(currentTab));
      setSearch(null);
    }
  }, [
    selectedTabState.get(),
    SilHomeselectedTabState.get(),
    slug,
    selectedTabSelector,
  ]);

  const recommendedForms = [
    "home-visit-checklist",
    "emergency-and-disaster-management-plan",
    "community-participation",
    "personal-care",
    "physical-activities",
    "behavioral-health-risk-assessment-form",
    "live-alone-participant-sole-worker-risk-factor-risk-assessment-form",
    "participant-physical-health-and-well-being",
  ];

  const fetchFormTempletes = async (slug, filters) => {
    if (!filters || filters === undefined) {
      Object.assign((filters = {}), {
        page: paginationObj.page,
      });
    }
    Object.assign(filters, { per_page: PARTICIPANT_LIST_LIMIT });
    // Set default sort if not already present to avoid duplication
    if (!filters.hasOwnProperty("sort_field")) {
      Object.assign(filters, {
        sort_field: "sequence",
        sort_order: SORT_TYPE.ASC,
      });
    }
    setRequest({ ...request, isRequested: true });
    try {
      const silUrl = addFiltersAndPagination(
        URL_SIL_ACCOMMODATION_FORM_LIST_BY_CATEGORY,
        filters
      );
      const url = addFiltersAndPagination(
        `${getUrlRole()}/form-templates-by`,
        filters
      );
      const urlHrm = addFiltersAndPagination(
        `${getUrlRole()}/hrm/form-templates-by`,
        filters
      );
      const urlCrm = addFiltersAndPagination(
        `worker/form-templates-by`,
        filters
      );
      let res = await apiGetRequest(
        `${
          role === "sil"
            ? silUrl
            : role === "hrm"
            ? urlHrm
            : role === "crm"
            ? urlCrm
            : url
        }&cat_slug=${slug}${
          filters.hasOwnProperty("sub_cat_uuid") &&
          filters.sub_cat_uuid !== "all"
            ? `&sub_cat_uuid=${filters.sub_cat_uuid}`
            : ""
        }&pt_uuid=${particpantUuid}${
          props.categoryUuid ? `&cat_uuid=${props.categoryUuid}` : ""
        }`
      );
      if (res.status !== 200) {
        setRequest({ ...request, isRequested: false, isFailed: true });
        toast.error(
          res?.data?.error ||
            res?.data?.message ||
            "Failed to load forms for this category."
        );
      } else if (res.status === 200) {
        setAllSelected(false);
        setCheckboxes([]);
        setRequest({ ...request, isRequested: false, isSuccess: true });
        if (slug === PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG) {
          setSupportPlans(res?.data?.data?.forms);
        } else setSupportPlans(res?.data?.data?.forms);
        setPaginationObj(
          getPaginationObj(res.data.data.forms, res.data.data.query_params)
        );
        const newShowToWorkerMap = {};
        if (res?.data?.data?.forms?.data) {
          res.data.data.forms.data.forEach((item) => {
            newShowToWorkerMap[item.id] = item.pt_form_show_to_worker;
          });
        }
        setShowToWorkerMap(newShowToWorkerMap);
      }
    } catch (err) {
      setRequest({ ...request, isRequested: false, isFailed: true });
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load forms for this category."
      );
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSearch(null);
    setAllSelected(false);
    setCheckboxes([]);
    if (toggleState?.hasOwnProperty("isModalOpen")) {
      const obj = {
        name: toggleState.name,
        id: toggleState.id,
        children: toggleState.children,
      };
      setToggleState(obj);
      selectedTabState.save(JSON.stringify(obj));
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
    fetchFormTempletes(`${slug}`);
  };

  useEffect(() => {
    setSortBy(paginationObj.sort_field ? paginationObj.sort_field : null);
    if (paginationObj.sort_order)
      setSortDescending(
        paginationObj.sort_order
          ? paginationObj.sort_order === SORT_TYPE.DESC
            ? true
            : false
          : false
      );
  }, [paginationObj]);

  useEffect(() => {
    const obj = { page: 1 };
    if (sortBy) {
      Object.assign(obj, {
        sort_field: paginationObj.sort_field ? paginationObj.sort_field : null,
        sort_order:
          paginationObj.sort_order === SORT_TYPE.DESC
            ? SORT_TYPE.DESC
            : SORT_TYPE.ASC,
      });
    }
    if (!search) handleFetch({ ...obj });
  }, []);

  const handleFetch = (obj = {}) => {
    const filter = _.cloneDeep(obj);
    if (paginationObj.page) Object.assign(filter, { page: paginationObj.page });
    if (paginationObj.filter && !obj.hasOwnProperty("status")) {
      Object.assign(filter, { filter: paginationObj.filter });
    }
    if (paginationObj.sort_field && !obj.hasOwnProperty("sort_field")) {
      Object.assign(filter, {
        sort_field: paginationObj.sort_field ? paginationObj.sort_field : null,
        sort_order:
          paginationObj.sort_order === SORT_TYPE.DESC
            ? SORT_TYPE.DESC
            : SORT_TYPE.ASC,
      });
    }
    if (obj.hasOwnProperty("search")) {
      Object.assign(filter, { page: 1, search: obj.search });
    }
    if (paginationObj.search && !obj.hasOwnProperty("search")) {
      Object.assign(filter, { search: paginationObj.search });
    }
    if (obj.status !== "both" && obj.hasOwnProperty("status")) {
      Object.assign(filter, {
        filter: {
          status: [obj.status],
        },
      });
    }
    if (obj.hasOwnProperty("page")) Object.assign(filter, { page: obj.page });
    if (obj.hasOwnProperty("sub_cat_uuid")) {
      Object.assign(filter, { sub_cat_uuid: obj.sub_cat_uuid });
    }
    if (isModalOpen) fetchFormTempletes(`${slug}`, { ...filter });
  };

  useEffect(() => {
    if (search === null) return;
    const timeOutId = setTimeout(
      () =>
        handleFetch({
          search: search,
          sub_cat_uuid: selectedSubCat?.value ? selectedSubCat?.value : "all",
        }),
      1000
    );
    return () => clearTimeout(timeOutId);
  }, [search]);

  const supportPlanToMap = useMemo(() => {
    if (
      supportPlans &&
      supportPlans.data &&
      (slug === PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG ||
        slug === PARENT_FORM_CATEGORY_SLUG.MEDICATION.SLUG)
    ) {
      return supportPlans.data.sort((a, b) =>
        a.sequence < b.sequence ? -1 : 1
      );
      // .sort((a, b) => (a.is_mandatory === "Mandatory" ? -1 : 1));
    } else if (supportPlans && supportPlans.data) {
      return supportPlans.data;
    }
    return [];
  }, [supportPlans]);

  const [fetchSubFormCatsLoader, setFetchSubFormCatsLoader] = useState(false);
  const [formCategories, setFormCategories] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState({
    label: "All",
    value: "all",
  });

  const fetchCategories = async () => {
    setFetchSubFormCatsLoader(true);
    try {
      const res = await apiCall.formCategoriesRequest({ role });
      const data = res.form_categories.map((x) => {
        const obj = {
          label: x.name,
          value: x.id,
        };
        return { ...x, ...obj };
      });
      setFormCategories([...data]);
      setFetchSubFormCatsLoader(false);
    } catch (err) {
      setFetchSubFormCatsLoader(false);
      toast.error(err.message);
    }
  };

  const getSubCategoriesByParentSlug = (val) => {
    if (!val) return [{ label: "All", value: "all" }];

    const customOrder = [
      { name: "Bowel Care Mgt", order: 1 },
      { name: "Complex Bowel ", order: 2 },
      { name: "Complex Wound", order: 3 },
      { name: "Disaster Mgt", order: 4 },
      { name: "Enteral Feed Mgt", order: 5 },
      { name: "Severe Dysphagia Mgt", order: 6 },
      { name: "Subcutaneous Injections", order: 7 },
      { name: "Tracheostomy Mgt", order: 8 },
      { name: "Urinary Catheter Mgt", order: 9 },
    ];

    if (formCategories?.length > 0) {
      const data =
        formCategories
          .find((X) => X.slug === val)
          ?.form_sub_categories?.map((item) => ({
            ...item,
            label: item.name,
            value: item.uuid,
          }))
          ?.sort((a, b) => {
            const orderA =
              customOrder.find(
                (category) =>
                  category.name.toLowerCase() === a.name.toLowerCase()
              )?.order || Infinity;
            const orderB =
              customOrder.find(
                (category) =>
                  category.name.toLowerCase() === b.name.toLowerCase()
              )?.order || Infinity;
            return orderA - orderB;
          }) || [];
      data?.unshift({ label: "All", value: "all" });
      return data;
    }
    return [{ label: "All", value: "all" }];
  };

  useEffect(() => {
    if (
      supportPlanToMap &&
      checkboxes &&
      checkboxes?.length === supportPlanToMap?.length &&
      supportPlanToMap?.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes]);
  useEffect(() => {
    if (!roleAccess([USER_ROLE.Sp_Standard_User])) {
      fetchCategories();
    }
    return () => {
      setSelectedSubCat(null);
      setFormCategories([]);
    };
  }, []);

  const toggleCheckboxes = (val) => {
    setCheckboxes(val ? supportPlanToMap?.map((el) => el) : []);
  };

  const handleCheckboxChange = (e, item) => {
    const filteredList = checkboxes?.filter((c) => c.id !== item.id);
    if (e) {
      filteredList.push(item);
    }
    setCheckboxes(filteredList);
  };

  // Listing API omits template JSON; load it only when emailing.
  const buildEmailFormPayload = async (items = []) => {
    return Promise.all(
      items.map(async (item) => {
        if (item?.template) {
          return {
            id: item.id,
            form_data: DATA_FORMATTER_FOR_DYNAMICS_FORMS(item.template),
          };
        }
        const res = await apiGetRequest(
          `${getUrlRole()}/form_template?form_template_slug=${item.slug}`
        );
        if (res?.status !== 200) {
          throw new Error(`Failed to load form template: ${item.slug}`);
        }
        return {
          id: item.id,
          form_data: DATA_FORMATTER_FOR_DYNAMICS_FORMS(res?.data?.data?.template),
        };
      })
    );
  };

  const handleSendEmail = async (emails, expiry_date) => {
    setEmailLoader(true);

    try {
      const formsToSend =
        checkboxes?.length > 0
          ? checkboxes
          : selectedFormForEmail
          ? [selectedFormForEmail]
          : [];
      const sp_form_temp_id = await buildEmailFormPayload(formsToSend);

      const payload = {
        is_complete: false,
        step: -1,
        created_by: currentLogedInUser?.id,
        pt_id: participantId,
        sp_form_temp_id,
        public_access_emails: emails?.length > 0 ? emails : [],
        form_public_access: true,
        expiry_date,
      };

      const res = await apiPostRequest(
        isFrontlineEmployeeUser()
          ? URL_FORM_SEND_EMAIL_FOR_WORKER
          : URL_FORM_SEND_EMAIL_FOR_SP,
        payload
      );
      if (res.status === 201) {
        setSelectedFormForEmail(null);
        setCheckboxes([]);
        setIsShowMultipleEmail(false);
        toast.success("E-from link sent successfully!");
      }
    } catch (error) {
      toast.error("E-from link not sent");
      setSelectedFormForEmail(null);
      console.error("Failed to send email:", error);
    } finally {
      setEmailLoader(false);
    }
  };

   const handleShowToWorkerToggle = async (item, checked) => {
  // ⭐ Instantly update UI
  setShowToWorkerMap((prev) => ({
    ...prev,
    [item.id]: checked,
  }));

  try {
    const payload = {
      pt_id: participantId,
      sp_form_temp_id: item.id,
      form_category_id: item.category_id,
    };

    const res = await apiPostRequest(URL_SHOW_OR_HIDE_PT_FORM_TO_WORKER, payload);


  } catch (err) {
    console.error("Failed to toggle form visibility:", err);

    setShowToWorkerMap((prev) => ({
      ...prev,
      [item.id]: !checked,
    }));
  }
};

  const Toggle = ({ checked, onChange }) => (
    <label className='relative inline-flex items-center justify-center cursor-pointer'>
      <input
        type='checkbox'
        className='sr-only peer'
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div
        className="form-admin-toggle w-10 h-5 rounded-full peer peer-checked:bg-blue-600
                    after:content-[''] after:absolute after:top-[2px] after:left-[2px]
                    after:w-4 after:h-4 after:bg-white after:rounded-full after:shadow-sm
                    after:transition-all peer-checked:after:translate-x-5"
      ></div>
    </label>
  );

  return (
    <>
      <CustomButton
        label={buttonText}
        Icon={<BiPlus />}
        clickHandler={openModal}
      />
      <ModalSkeleton
        isOpen={isModalOpen}
        closeModal={() => closeModal()}
        cssClass='w-[60%]'
        title={
          slug === PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG
            ? "Risk Evaluation"
            : buttonText
        }
      >
        <>
          <div className='form-modal-toolbar'>
            <div className='form-modal-toolbar-actions'>
              {slug === PARENT_FORM_CATEGORY_SLUG.HIGH_CARE.SLUG && (
                <div className='w-2/5 md:w-4/12 lg:w-4/12'>
                  <SelectOption
                    isDisabled={fetchSubFormCatsLoader}
                    loading={fetchSubFormCatsLoader}
                    isSearch={false}
                    selectedOption={selectedSubCat}
                    handleChange={(e) => {
                      setSelectedSubCat(e);
                      handleFetch({ sub_cat_uuid: e.value, page: 1 });
                    }}
                    data={getSubCategoriesByParentSlug(slug)}
                    placeHolder='Filter Sub-Category'
                  />
                </div>
              )}

              {canSendParticipantEform && role !== "sil" ? (
                <>
                  <CustomButton
                    label='send selected forms via email'
                    Icon={<MdMarkEmailRead />}
                    clickHandler={() => setIsShowMultipleEmail(true)}
                    isDisabled={checkboxes?.length === 0}
                  />
                  {/* <CustomButton
                    label={`Delete Selected (${checkboxes?.length || 0})`}
                    Icon={<HiOutlineTrash />}
                    clickHandler={() => setOpenBulkDeleteModal(true)}
                    isDisabled={checkboxes?.length === 0}
                    variant='danger'
                    cssClass='text-sm'
                  /> */}
                </>
              ) : null}
            </div>
            <div className='form-modal-toolbar-search'>
              <Search setSearch={setSearch} search={search} />
            </div>
          </div>
          <div className='form-admin-table-card mb-5'>
            {request.isRequested ? (
              <div className='flex justify-center items-center custom-width-min min-h-[200px]'>
                <CircularLoader
                  classes='flex justify-center items-center'
                  classloader='loader-l'
                />
              </div>
            ) : (
              <table className='form-table min-w-full mb-0 capitalize'>
                <thead className='sticky top-0 z-[30]'>
                  {" "}
                  <tr>
                    {canSendParticipantEform && role !== "sil" && (
                        <th
                          scope='col'
                          className='form-table-checkbox-col py-3.5 text-sm font-semibold'
                        >
                          <div className='flex items-center justify-center'>
                          <CheckBox
                            checked={allSelected}
                            handleChange={(e) => {
                              if (supportPlanToMap?.length > 0) {
                                setAllSelected(e);
                                toggleCheckboxes(e);
                              }
                            }}
                          />
                          </div>
                        </th>
                      )}

                    {showSerialColumn && (
                      <th
                        scope='col'
                        className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-6 w-16'
                      >
                        Sr.
                      </th>
                    )}
                    <th
                      scope='col'
                      className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-6'
                    >
                      Title
                    </th>
                    <th
                      scope='col'
                      className='px-3 py-3.5 text-left text-sm font-semibold '
                    >
                      Category
                    </th>
                    {(slug === PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG ||
                      slug === PARENT_FORM_CATEGORY_SLUG.HIGH_CARE.SLUG) && (
                      <th
                        scope='col'
                        className='px-3 py-3.5 text-left text-sm font-semibold '
                      >
                        Sub Category
                      </th>
                    )}
                    {/* {slug ===
                      PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG && (
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold "
                      >
                        Priority
                      </th>
                    )} */}
                    {!roleAccess([USER_ROLE.Sp_Standard_User]) && (
                      <th
                        scope='col'
                        className='form-table-toggle-col py-3.5 text-sm font-semibold'
                      >
                        Show to worker
                      </th>
                    )}
                    <ActionsForSubmitPtForms
                      slug={slug}
                      view={"table_header"}
                    />
                  </tr>
                </thead>
                <tbody>
                  {supportPlanToMap?.map((item, index) => {
                    return (
                      <tr key={item.uuid}>
                        {canSendParticipantEform && role !== "sil" && (
                            <td className='form-table-checkbox-col whitespace-nowrap py-4 text-sm'>
                              <div>
                                <CheckBox
                                  handleChange={(e) =>
                                    handleCheckboxChange(e, item)
                                  }
                                  checked={checkboxes?.indexOf(item) !== -1}
                                />
                              </div>
                            </td>
                          )}

                        {showSerialColumn && (
                          <td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6 align-middle'>
                            <div className='capitalize font-medium text-gray-900'>
                              {index + 1}
                            </div>
                          </td>
                        )}
                        <td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6'>
                          <div className='flex items-center'>
                            <div className=''>
                              <div className='flex items-center font-medium text-gray-900 capitalize'>
                                <span className='truncate'>{item.title}</span>
                                {recommendedForms.includes(item.slug) && (
                                  <span className='form-recommended-badge'>
                                    Recommended
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                          <div className='text-gray-900'>
                            {item.category_name}
                          </div>
                        </td>
                        {(slug ===
                          PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG ||
                          slug ===
                            PARENT_FORM_CATEGORY_SLUG.HIGH_CARE.SLUG) && (
                          <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                            <div className='text-gray-900'>
                              {item.sub_category_name
                                ? item.sub_category_name
                                : "-"}
                            </div>
                          </td>
                        )}
                        {/* {slug ===
                          PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT
                            .SLUG && (
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            <div className="text-gray-900">
                              {item.is_mandatory ? "Mandatory" : "Optional"}
                            </div>
                          </td>

                        )} */}
                        {!roleAccess([USER_ROLE.Sp_Standard_User]) && (
                          <td className='form-table-toggle-col whitespace-nowrap py-4'>
                            <div className='form-table-toggle-inner'>
                              <Toggle
                                checked={!!showToWorkerMap[item.id]}
                                onChange={(checked) =>
                                  handleShowToWorkerToggle(item, checked)
                                }
                              />
                            </div>
                          </td>
                        )}
                        <ActionsForSubmitPtForms
                          particpantUuid={particpantUuid}
                          item={item}
                          slug={slug}
                          view={"table_data"}
                          setIsShowMultipleEmail={setIsShowMultipleEmail}
                          role={role}
                          setSelectedFormForEmail={setSelectedFormForEmail}
                          checkboxes={checkboxes}
                        />
                      </tr>
                    );
                  })}
                  {supportPlans?.data?.length === 0 ? (
                    <tr>
                      <td colSpan={7} className='py-6 text-center text-red-600'>
                        No data found !
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            )}
          </div>
          {paginationObj.total > 0 && (
            <div className='bg-white w-full pt-8 pb-10 mt-8 border-t border-gray-200'>
              <PaginationComponent
                page={paginationObj.page}
                activeListLength={supportPlanToMap ? supportPlanToMap : []}
                limit={PARTICIPANT_LIST_LIMIT}
                totalList={paginationObj.total}
                handlePagination={(e) => {
                  const data = _.cloneDeep(paginationObj);
                  const obj = paginationObj;
                  obj.page = e;
                  setPaginationObj({ ...obj });
                  setAllSelected(false);
                  setCheckboxes([]);
                  if (e !== data.page) {
                    handleFetch({});
                  }
                }}
                totalPages={paginationObj.totalPages}
              />
            </div>
          )}

          {isShowMultipleEmail && (
            <MultipleEmailModal
              // defaultData={supportPlanToMap?.public_access_users}
              showModal={isShowMultipleEmail}
              closeModalHandler={() => {
                setIsShowMultipleEmail(false);
              }}
              onClick={handleSendEmail}
              emailSendLoader={emailSendLoader}
            />
          )}
          {openBulkDeleteModal && (
            <BulkDeleteFormModal
              open={openBulkDeleteModal}
              setOpen={setOpenBulkDeleteModal}
              selectedForms={checkboxes?.map((item) => item.uuid) || []}
              role={role}
              refreshFormList={() => {
                setCheckboxes([]);
                setAllSelected(false);
                fetchFormTempletes(`${slug}`, { page: paginationObj.page });
              }}
              parentSlug={slug}
            />
          )}
        </>
      </ModalSkeleton>
    </>
  );
};

export default CategoryFormsListing;
